// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___Fg8B6";
var _2 = "styles-module__coordinatesAndLanguageBtn___p67gC";
var _3 = "styles-module__descriptionText___W304D";
var _4 = "styles-module__doneButton___dL7P6";
var _5 = "styles-module__dragHandle___QwiVB";
var _6 = "styles-module__latLng___xUZx7";
var _7 = "styles-module__nameText___pyoLo";
var _8 = "styles-module__numberAndName___FzTM0";
var _9 = "styles-module__orderNumber___DEczn";
var _a = "styles-module__topSection___C3UF9";
export { _1 as "container", _2 as "coordinatesAndLanguageBtn", _3 as "descriptionText", _4 as "doneButton", _5 as "dragHandle", _6 as "latLng", _7 as "nameText", _8 as "numberAndName", _9 as "orderNumber", _a as "topSection" }
